import { tableAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(
    tableAnatomy.keys
);

const baseStyle = definePartsStyle({
    thead: {
        background: 'neutral.200',
        tr: {
            'th:first-of-type': {
                borderTopLeftRadius: '4px'
            },
            'th:last-of-type': {
                borderTopRightRadius: '4px'
            },
            th: {
                color: 'neutral.600',
                fontSize: '14px',
                paddingY: '18px'
            }
        }
    },
    tbody: {
        color: 'neutral.600',
        tr: {
            _hover: {
                backgroundColor: 'neutral.100'
            }
        }
    }
});

export const tableTheme = defineMultiStyleConfig({ baseStyle });
